import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const useAuth = () => {
  const localStorageUser = localStorage.getItem("user");
  const [isAuth, setIsAuth] = useState(!!localStorageUser);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const publicRoutes = ["/", "/reset-password", "/reset-password-request"];
    if (!localStorageUser) {
      setIsAuth(false);

      !publicRoutes.includes(pathname) && navigate("/");
    }

    if (localStorageUser) {
      setIsAuth(true);
    }
  }, [navigate, localStorageUser, pathname]);

  return { isAuth };
};
